import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserSupportComponent } from './user-support.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { UserSupportRoutingModule } from './user-support-routing.module';
import { MatRadioModule } from '@angular/material/radio';
import { MeetingRoomComponent } from '../meeting-room/meeting-room.component';
import { ServiceInformationModule } from '../service-Information/service-information.module';
import { JitsiMeetingComponent } from '../jitsi-meeting/jitsi-meeting.component';
import { PatientHealthPanelComponent } from './components/patient-health-panel/patient-health-panel.component';

const components = [UserSupportComponent, MeetingRoomComponent, JitsiMeetingComponent, PatientHealthPanelComponent];

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    UserSupportRoutingModule,
    SharedModule,
    MatMenuModule,
    MatIconModule,
    MatRadioModule,
    ServiceInformationModule
  ],
  declarations: [...components]
})
export class UserSupportModule {}
